import React, { useState, useEffect } from "react";
import DynamicModal from "../dynamic-modal";
import { Box, Text, Image, Flex } from "@chakra-ui/react";
import moment from "moment";
import TabSection from "../tabs";
import DateRangeIndex from "../patient-health/vital-display-card/date-range";
import AreaPlotChart from "../patient-health/vital-display-card/areaplotchart";
import GroupedColumnRangePlot from "../patient-health/vital-display-card/columnrangechart";
import { FetchVitalsData } from "../../middleware/services/vitalschart";
import GrayCard from "../card";
import PrimaryButton from "../primary-button";
import { COLORS } from "../styles/colors";
import LabTableView from "../../pages/messages/labtableview";
import { EditVitalData } from "../../middleware/services/messages";
import DatePicker from "../date-picker";
import PrimaryInput from "../primary-input";

const statusColorMap = {
  Ok: "green.500",
  Low: "orange.300",
  High: "red.500",
};

const statusIconMap = {
  Ok: "/assets/svgs/ok.svg",
  Normal: "/assets/svgs/ok.svg",
  Low: "/assets/svgs/low.svg",
  High: "/assets/svgs/high.svg",
};

const formatDate = (dateString) => {
  if (!dateString) return "-";
  return moment(dateString).format("Do MMM, YYYY");
};

const ProfileVitalDisplayCard = ({ vitals, patientId, doctorId, appointmentId, showLoader, dismissLoader, showSuccessToast, showErrorToast, fetchVitalsRef }) => {
  const editVitals = React.useRef();

  const [activeViewTab, setActiveViewTab] = useState("Tabular View");
  const [selectedVital, setSelectedVital] = useState(null);
const [editValue, setEditValue] = useState("");
const [vitalsState, setVitalsState] = useState(vitals);
const [selectedBP, setSelectedBP] = useState(null); // { systolic, diastolic }
const [editSystolic, setEditSystolic] = useState("");
const [editDiastolic, setEditDiastolic] = useState("");
const [editDate, setEditDate] = useState(""); // For single vital
const [editBPDate, setEditBPDate] = useState("");

  // const [vitalsArray, setVitalsArray] = useState(null);


  // useEffect(() => {
  //   console.log('appoinement id : ', appointmentId)
  //   // console.log('[DEBUG] vitals type:', typeof vitals);
  //   console.log('vitals : ', vitals)
  // //   const vitalsArr = Array.isArray(vitals) 
  // // ? vitals 
  // // : Object.values(vitals || {});
  // // setVitalsArray(vitalsArr)
  // // console.log('[DEBUG] Processed vitals array:', vitalsArr);

  // }, [appointmentId])
  const handleViewTabClick = (index) => {
    switch (index) {
      case 0:
        setActiveViewTab("Tabular View");
        break;
      case 1:
        setActiveViewTab("Graphs View");
        if(appointmentId) {
          fetchFilterDataIPD(patientId, appointmentId)
        } else {
          fetchFilterData(thisyearstartdate, "Year");
        }
        break;

      default:
        break;
    }
  };

  const today = moment().format("YYYY-MM-DD HH:mm:ss.SSS");
  const thisweekstartdate = moment()
    .startOf("week")
    .format("YYYY-MM-DD HH:mm:ss.SSS");
  const thismonthstartdate = moment()
    .startOf("month")
    .format("YYYY-MM-DD HH:mm:ss.SSS");
  const thisyearstartdate = moment()
    .startOf("year")
    .format("YYYY-MM-DD HH:mm:ss.SSS");
  // This is to by default set this week dates
  const [activeTab, setActiveTab] = useState(thisyearstartdate);

  const [data, setData] = useState(null);

  const [oxygensaturationlabel, setOxygenSaturationLabel] = useState(null);
  const [pulselabel, setPulseLabel] = useState(null);
  const [fastingLable, setFastingLabel] = useState(null);
  const [postGlucoseLabel, setPostGlucoseLabel] = useState(null);
  const [bodytemplabel, setBodyTempLabel] = useState(null);
  const [respiratorylabel, setRespiratoryLabel] = useState(null);
  const openCalendar = React.useRef(null);

  const [isCalendarVisible, setCalendarVisibility] = useState(false);

  const handleTabClick = (index) => {
    switch (index) {
      case 0:
        setActiveTab(today);
        fetchFilterData(today, "Today");
        break;
      case 1:
        setActiveTab(thisweekstartdate);
        fetchFilterData(thisweekstartdate, "Week");
        break;
      case 2:
        setActiveTab(thismonthstartdate);
        fetchFilterData(thismonthstartdate, "Month");
        break;
      case 3:
        setActiveTab(thisyearstartdate);
        fetchFilterData(thisyearstartdate, "Year");
        break;

      default:
        break;
    }
  };

  const handleCalendar = () => {
    setCalendarVisibility(!isCalendarVisible);
    // openCalendar.current.toggleCalendar();
  };

  const fetchFilterData = async (fromdate, type) => {
    showLoader();
    try {
      const result = await FetchVitalsData(
        {
          patientid: patientId,
          type: "",
      //     ...(appointmentId ? { appointment_id: appointmentId } : {
      //   fromdate: fromdate,
      //   todate: today
      // })
          fromdate: fromdate,
          todate: today,
        },
        type
      );
      if (result != null) {
        setData(result);
        // if (result.weight.length > 0) {
        //   const weightobject = result.weight[result.weight.length - 1].value;
        //   setWeightLabel(weightobject);
        // }
        // if (result.height.length > 0) {
        //   const heightobject = result.height[result.height.length - 1].value;
        //   setHeightLabel(heightobject);

        //   const convertedValuesToNeumeric = result.height.map(item => ({
        //     ...item,
        //     value: formatNumber(item.value),
        // }));

        //   setHeightValuesToNumeric(convertedValuesToNeumeric)

        // }
        if (result.oxygensaturation.length > 0) {
          const oxygensaturationobject =
            result.oxygensaturation[result.oxygensaturation.length - 1].value;
          setOxygenSaturationLabel(oxygensaturationobject);
        }
        if (result.pulse.length > 0) {
          const pulseobject = result.pulse[result.pulse.length - 1].value;
          setPulseLabel(pulseobject);
        }
        if (result.fastingbloodglucose.length > 0) {
          const fastinglucoseobject = result.fastingbloodglucose[result.fastingbloodglucose.length - 1].value;
          setFastingLabel(fastinglucoseobject);
        }
        if (result.postprandialbloodglucose.length > 0) {
          const postbloodobject = result.postprandialbloodglucose[result.postprandialbloodglucose.length - 1].value;
          setPostGlucoseLabel(postbloodobject);
        }
        if (result.bodytemperature.length > 0) {
          const bodytempuratureobject =
            result.bodytemperature[result.bodytemperature.length - 1].value;
          setBodyTempLabel(bodytempuratureobject);
        }
        if (result.respiratoryrate.length) {
          const respiratoryrateobject =
            result.respiratoryrate[result.respiratoryrate.length - 1].value;
          setRespiratoryLabel(respiratoryrateobject);
        }
      } else {
        // alert("No data");
      }
      dismissLoader();
    } catch (error) {
      console.error("Error in DashboardIndex:", error);
    }
  };
  const fetchFilterDataIPD = async (pid, aid) => {
    showLoader();
    try {
      const result = await FetchVitalsData(
        {
          patientid: pid,
          type: "",
          appointmentid: aid,
          // fromdate: fromdate,
          // todate: today,
        },
        // type
      );
      if (result != null) {
        setData(result);
        // if (result.weight.length > 0) {
        //   const weightobject = result.weight[result.weight.length - 1].value;
        //   setWeightLabel(weightobject);
        // }
        // if (result.height.length > 0) {
        //   const heightobject = result.height[result.height.length - 1].value;
        //   setHeightLabel(heightobject);

        //   const convertedValuesToNeumeric = result.height.map(item => ({
        //     ...item,
        //     value: formatNumber(item.value),
        // }));

        //   setHeightValuesToNumeric(convertedValuesToNeumeric)

        // }
        if (result.oxygensaturation.length > 0) {
          const oxygensaturationobject =
            result.oxygensaturation[result.oxygensaturation.length - 1].value;
          setOxygenSaturationLabel(oxygensaturationobject);
        }
        if (result.pulse.length > 0) {
          const pulseobject = result.pulse[result.pulse.length - 1].value;
          setPulseLabel(pulseobject);
        }
        if (result.fastingbloodglucose.length > 0) {
          const fastinglucoseobject = result.fastingbloodglucose[result.fastingbloodglucose.length - 1].value;
          setFastingLabel(fastinglucoseobject);
        }
        if (result.postprandialbloodglucose.length > 0) {
          const postbloodobject = result.postprandialbloodglucose[result.postprandialbloodglucose.length - 1].value;
          setPostGlucoseLabel(postbloodobject);
        }
        if (result.bodytemperature.length > 0) {
          const bodytempuratureobject =
            result.bodytemperature[result.bodytemperature.length - 1].value;
          setBodyTempLabel(bodytempuratureobject);
        }
        if (result.respiratoryrate.length) {
          const respiratoryrateobject =
            result.respiratoryrate[result.respiratoryrate.length - 1].value;
          setRespiratoryLabel(respiratoryrateobject);
        }
      } else {
        // alert("No data");
      }
      dismissLoader();
    } catch (error) {
      console.error("Error in DashboardIndex:", error);
    }
  };

  useEffect(() => {
    if(appointmentId) {
      fetchFilterDataIPD(patientId, appointmentId);
    } else {
      fetchFilterData(thisyearstartdate, "Year");
    }
  }, []);

  const handlerangedate = async (selecteddate) => {
    showLoader();
    try {
      const result = await FetchVitalsData({
        patientid: patientId,
        type: "",
        ...(appointmentId ? { appointmentid: appointmentId } : {
        fromdate: selecteddate.startDate,
        todate: selecteddate.endDate
      })
        // fromdate: selecteddate.startDate,
        // todate: selecteddate.endDate,
      });
      if (result != null) {
        setData(result);
        // if (result.weight.length > 0) {
        //   const weightobject = result.weight[result.weight.length - 1].value;
        //   setWeightLabel(weightobject);
        // }
        // if (result.height.length > 0) {
        //   const heightobject = result.height[result.height.length - 1].value;
        //   setHeightLabel(heightobject);
        // }
        if (result.oxygensaturation.length > 0) {
          const oxygensaturationobject =
            result.oxygensaturation[result.oxygensaturation.length - 1].value;
          setOxygenSaturationLabel(oxygensaturationobject);
        }
        if (result.pulse.length > 0) {
          const pulseobject = result.pulse[result.pulse.length - 1].value;
          setPulseLabel(pulseobject);
        }
        if (result.fastingbloodglucose.length > 0) {
          const fastinglucoseobject = result.fastingbloodglucose[result.fastingbloodglucose.length - 1].value;
          setFastingLabel(fastinglucoseobject);
        }
        if (result.postprandialbloodglucose.length > 0) {
          const postbloodobject = result.postprandialbloodglucose[result.postprandialbloodglucose.length - 1].value;
          setPostGlucoseLabel(postbloodobject);
        }
        if (result.bodytemperature.length > 0) {
          const bodytempuratureobject =
            result.bodytemperature[result.bodytemperature.length - 1].value;
          setBodyTempLabel(bodytempuratureobject);
        }
        if (result.respiratoryrate.length) {
          const respiratoryrateobject =
            result.respiratoryrate[result.respiratoryrate.length - 1].value;
          setRespiratoryLabel(respiratoryrateobject);
        }
      } else {
        console.error("No data");
      }
      dismissLoader();
    } catch (error) {
      console.error("Error in DashboardIndex:", error);
    }
  };

  const showGraphs = () => {
    setActiveViewTab("Graphs View");
  }
  const navigateBack = () => {
    setActiveViewTab("Tabular View");
  }
  // VitalCard component (extracted from your existing code)
// Updated VitalCard component
const VitalCard = ({ vital, showGraphs, flex, width }) => {
  const statusColor = statusColorMap[vital.status] || "gray.500";
  const statusIcon = statusIconMap[vital.status] || "";

  return (
    <Box
      border="1px"
      borderColor="#E6E7E9"
      borderRadius="md"
      p={4}
      backgroundColor="white"
      flex={flex}
      width={width}
      mb={4}
    >
      <Box display='flex' justifyContent='space-between' alignItems='center'>
        <Box display="flex" flexDirection="column" flex="1">
          <Text fontSize="12px" fontWeight="500" color="#6A707D">
            {vital.vitalname}
          </Text>
          <Box display="flex" alignItems="baseline">
            <Text
              fontSize={{ base: "18px", md: "22px" }}
              fontWeight="600"
            >
              {vital.vitalvalue}
            </Text>
            <Text
              fontSize={{ base: "12px", md: "15px" }}
              pl="5px"
              fontWeight="400"
            >
              {vital.vitalunit}
            </Text>
          </Box>
        </Box>
        <Box
          as="button"
          border="1px solid #E6E7E9"
          borderRadius="full"
          w="32px"
          h="32px"
          p="6px"
          display="flex"
          justifyContent="center"
          alignItems="center"
          onClick={showGraphs}
        >
          <Image 
            w="100%"
            h='16px'
            opacity="0.35"
            src="/assets/svgs/analytics.svg"
          />
        </Box>
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt="0.5rem"
      >
        <Text fontSize="12px" fontWeight="500" color="#6A707D">
          {formatDate(vital.vitaladdeddate)}
        </Text>
        <Box display="flex" alignItems="center" gap="0.25rem">
          {statusIcon && <Image w="12px" h="auto" src={statusIcon} />}
          <Text
            as="span"
            fontSize="12px"
            fontWeight="600"
            color={statusColor}
          >
            {vital.vitalstatus}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

const getStatusColor = (status) => {
  switch(status?.toLowerCase()) {
    case 'high': return 'red';
    case 'low': return 'blue';
    case 'normal': return 'green';
    default: return 'gray';
  }
};

const vitalDisplayOrder = [
  "Body temperature",
  "Heart rate",
  "Respiratory",
  "BP",
  "SPO2",
  "Fasting Blood Glucose",
  "Postprandial Blood Glucose"
];

// Helper function to pair systolic and diastolic readings by timestamp
const pairBloodPressures = (vitals) => {
  const systolicReadings = vitals.filter(v => v.vitalname === "Systolic Blood Pressure");
  const diastolicReadings = vitals.filter(v => v.vitalname === "Diastolic Blood Pressure");
  
  return systolicReadings.map(systolic => {
    // Find diastolic reading with same timestamp
    const diastolic = diastolicReadings.find(
      d => d.vitaladdeddate === systolic.vitaladdeddate
    );
    
    return {
      ...systolic,
      pairedValue: diastolic ? `${systolic.vitalvalue}/${diastolic.vitalvalue}` : `${systolic.vitalvalue}/-`,
      pairedDate: systolic.vitaladdeddate,
      // Use the more critical status if both exist
      pairedStatus: diastolic 
        ? (systolic.STATUS > diastolic.STATUS ? systolic.STATUS : diastolic.STATUS)
        : systolic.STATUS
    };
  });
};


const editModalfunc = (id, isBP = false, bpDate = null) => {
  if (isBP && bpDate) {
    // Find both systolic and diastolic for this date
    const systolic = vitals.find(v => v.vitalname === "Systolic Blood Pressure" && v.vitaladdeddate === bpDate);
    const diastolic = vitals.find(v => v.vitalname === "Diastolic Blood Pressure" && v.vitaladdeddate === bpDate);
    setSelectedBP({ systolic, diastolic });
    setEditSystolic(systolic?.vitalvalue ?? "");
    setEditDiastolic(diastolic?.vitalvalue ?? "");
    setEditBPDate(bpDate ? moment(bpDate).format("DD-MM-YYYY") : "");
    // setEditBPDate(bpDate ? moment(bpDate).format("YYYY-MM-DD") : "");
    setSelectedVital(null);
  } else {
    const vital = vitals.find(v => v.patientvitalid === id);
    setSelectedVital(vital);
    setEditValue(vital?.vitalvalue ?? "");
    setEditDate(vital?.vitaladdeddate ? moment(vital.vitaladdeddate).format("DD-MM-YYYY") : "");
    setSelectedBP(null);
  }
  editVitals.current.openModal();
};

// const editModalfunc = (id) => {
//   // Find the vital by id from vitals array
//   const vital = vitals.find(v => v.patientvitalid === id);
//   setSelectedVital(vital);
//   setEditValue(vital?.vitalvalue ?? "");
//   editVitals.current.openModal();
// }

const editBPVitals = async (systolic, diastolic, newSystolic, newDiastolic) => {
  // Example API call structure
  const payload = {
    vitals: [
      {
        patientvitalid: systolic.patientvitalid,
        vitalname: "Systolic Blood Pressure",
        vitalvalue: newSystolic,
        vitalunit: systolic.vitalunit,
        vitaladdeddate: systolic.vitaladdeddate,
      },
      {
        patientvitalid: diastolic.patientvitalid,
        vitalname: "Diastolic Blood Pressure",
        vitalvalue: newDiastolic,
        vitalunit: diastolic.vitalunit,
        vitaladdeddate: diastolic.vitaladdeddate,
      }
    ]
  };
  // await YourEditVitalsAPI(payload);
};

const editSingleVital = async (vital, newValue) => {
  const payload = {
    patientvitalid: vital.patientvitalid,
    vitalname: vital.vitalname,
    vitalvalue: newValue,
    vitalunit: vital.vitalunit,
    vitaladdeddate: vital.vitaladdeddate,
  };
  // await YourEditVitalsAPI(payload);
};

// const handleEditVital = async () => {
//   showLoader && showLoader();

//   let vitalsToEdit = [];
//   if (selectedBP) {
//     // BP: Systolic & Diastolic
//     if (selectedBP.systolic && editSystolic !== "") {
//       vitalsToEdit.push({
//         patientvitalid: selectedBP.systolic.patientvitalid,
//         doctorid: doctorId,
//         vitalvalue: editSystolic,
//         iscurrent: 1,
//         vitalunit: selectedBP.systolic.vitalunit,
//         vitalname: "Systolic Blood Pressure",
//         vitaladdeddate: selectedBP.systolic.vitaladdeddate,
//       });
//     }
//     if (selectedBP.diastolic && editDiastolic !== "") {
//       vitalsToEdit.push({
//         patientvitalid: selectedBP.diastolic.patientvitalid,
//         doctorid: doctorId,
//         vitalvalue: editDiastolic,
//         iscurrent: 1,
//         vitalunit: selectedBP.diastolic.vitalunit,
//         vitalname: "Diastolic Blood Pressure",
//         vitaladdeddate: selectedBP.diastolic.vitaladdeddate,
//       });
//     }
//   } else if (selectedVital) {
//     // Single vital
//     vitalsToEdit.push({
//       patientvitalid: selectedVital.patientvitalid,
//       doctorid: doctorId,
//       vitalvalue: editValue,
//       iscurrent: 1,
//       vitalunit: selectedVital.vitalunit,
//       vitalname: selectedVital.vitalname,
//       vitaladdeddate: selectedVital.vitaladdeddate,
//     });
//   }

//   const inputToEdit = {
//     input: {
//       doctorid: doctorId,
//       patientid: patientId,
//       ...(appointmentId && { appointment_id: appointmentId }),
//       updatedby: doctorId,
//       updateddate: moment().format("YYYY-MM-DD HH:mm:ss"),
//       vitals: vitalsToEdit,
//     },
//   };

//   try {
//     if (vitalsToEdit.length > 0) {
//       const result = await EditVitalData(inputToEdit.input);
//       if (result && result.output && result.output.message === "Successfully Updated") {
//         // Update local state
//         setVitalsState(prev =>
//           prev.map(v =>
//             vitalsToEdit.find(edited => edited.patientvitalid === v.patientvitalid)
//               ? { ...v, vitalvalue: vitalsToEdit.find(edited => edited.patientvitalid === v.patientvitalid).vitalvalue }
//               : v
//           )
//         );
//         showSuccessToast && showSuccessToast("Vitals updated successfully");
//         editVitals.current.closeModal();
//       }
//     }
//   } catch (error) {
//     console.error("Error in handleEditVital:", error);
//   }
//   dismissLoader && dismissLoader();
// };

const handleEditVital = async () => {
  showLoader && showLoader();

  // Helper to send single vital edit
  const sendEdit = async (vitalObj) => {
    // Convert DD-MM-YYYY to YYYY-MM-DDTHH:mm:ss for API
    let apiDate = vitalObj.vitaladdeddate;
    if (apiDate && apiDate.includes('-') && apiDate.length === 10) {
      apiDate = moment(apiDate, "DD-MM-YYYY").format("YYYY-MM-DDT00:00:00");
    }
    const inputToEdit = {
      input: {
        patientvitalid: vitalObj.patientvitalid,
        // doctorid: doctorId,
        ...(appointmentId && { appointment_id: appointmentId }),
        vitalvalue: vitalObj.vitalvalue,
        iscurrent: vitalObj.iscurrent,
        vitalunit: vitalObj.vitalunit,
        // vitaladdeddate: vitalObj.vitaladdeddate,
        // vitaladdeddate: vitalObj.apiDate,
        vitaladdeddate: apiDate,
        // updatedby: doctorId
      }
    };
    return await EditVitalData(inputToEdit.input);
  };

  try {
    let success = false;
    if (selectedBP) {
      // BP: Systolic & Diastolic (call API for each)
      if (selectedBP.systolic && editSystolic !== "") {
        const resultSys = await sendEdit({
          patientvitalid: selectedBP.systolic.patientvitalid,
          vitalvalue: editSystolic,
          vitalunit: selectedBP.systolic.vitalunit,
          // vitaladdeddate: selectedBP.systolic.vitaladdeddate,
          // vitaladdeddate: editBPDate ? moment(editBPDate).format("YYYY-MM-DDTHH:mm:ss") : selectedBP.systolic.vitaladdeddate,
          vitaladdeddate: editBPDate,
          iscurrent: selectedBP.systolic.iscurrent,
        });
        success = success || (resultSys && resultSys.output && resultSys.output.message === "Successfully Updated");
      }
      if (selectedBP.diastolic && editDiastolic !== "") {
        const resultDia = await sendEdit({
          patientvitalid: selectedBP.diastolic.patientvitalid,
          vitalvalue: editDiastolic,
          vitalunit: selectedBP.diastolic.vitalunit,
          // vitaladdeddate: selectedBP.diastolic.vitaladdeddate,
          //  vitaladdeddate: editBPDate ? moment(editBPDate).format("YYYY-MM-DDTHH:mm:ss") : selectedBP.diastolic.vitaladdeddate,
          vitaladdeddate: editBPDate,
          iscurrent: selectedBP.diastolic.iscurrent,
        });
        success = success || (resultDia && resultDia.output && resultDia.output.message === "Successfully Updated");
      }

      setVitalsState(prev =>
        prev.map(v =>
          v.patientvitalid === selectedBP.systolic.patientvitalid
            ? { ...v, vitalvalue: editSystolic, vitaladdeddate: editBPDate }
            : v.patientvitalid === selectedBP.diastolic.patientvitalid
            ? { ...v, vitalvalue: editDiastolic, vitaladdeddate: editBPDate }
            : v
        )
      );
      // Update local state
      // setVitalsState(prev =>
      //   prev.map(v =>
      //     v.patientvitalid === selectedBP.systolic.patientvitalid
      //       ? { ...v, vitalvalue: editSystolic }
      //       : v.patientvitalid === selectedBP.diastolic.patientvitalid
      //       ? { ...v, vitalvalue: editDiastolic }
      //       : v
      //   )
      // );


    } else if (selectedVital) {
      // Single vital
      const result = await sendEdit({
        patientvitalid: selectedVital.patientvitalid,
        vitalvalue: editValue,
        vitalunit: selectedVital.vitalunit,
        // vitaladdeddate: selectedVital.vitaladdeddate,
        // vitaladdeddate: editDate ? moment(editDate).format("YYYY-MM-DDTHH:mm:ss") : selectedVital.vitaladdeddate,
        vitaladdeddate: editDate,
        iscurrent: selectedVital.iscurrent,
      });
      success = result && result.output && result.output.message === "Successfully Updated";
      // setVitalsState(prev =>
      //   prev.map(v =>
      //     v.patientvitalid === selectedVital.patientvitalid
      //       ? { ...v, vitalvalue: editValue }
      //       : v
      //   )
      // );
      setVitalsState(prev =>
        prev.map(v =>
          v.patientvitalid === selectedVital.patientvitalid
            ? { ...v, vitalvalue: editValue, vitaladdeddate: editDate }
            : v
        )
      );
    }
    if (success) {
      showSuccessToast && showSuccessToast("Vitals updated successfully");
      editVitals.current.closeModal();
      // Call fetchVitalsRef to refresh data
      if (typeof fetchVitalsRef === "function") {
        fetchVitalsRef(patientId, appointmentId);
      }
    }
  } catch (error) {
    console.error("Error in handleEditVital:", error);
  }
  dismissLoader && dismissLoader();
};
// const handleEditVital = async () => {    
// // Format date and time
//   // let updateddate = addDate && addTime
//   //   ? moment(addDate, "DD-MM-YYYY").format("YYYY-MM-DD") + " " + addTime
//   //   : moment().format("YYYY-MM-DD HH:mm:ss");

//   // Prepare input payload
//   const inputToEdit = {
//     input: {
//       // doctorid: doctorid,
//       ...(appointmentId && { appointment_id: appointmentId }),
//       // patientid: patientid,
//       updatedby: updatedby,
//       updateddate: updateddate,
//       vitals: editVitalsArray
//         .filter(vital => vital.vitalvalue !== "")
//         .map(vital => ({
//           patientvitalid: vital.patientvitalid,
//           vitalname: vital.vitalname,
//           vitalvalue: vital.vitalvalue,
//           vitalunit: vital.vitalunit,
//           vitaltype_cd: vital.vitaltype_cd || "",
//           vitaladdeddate: vital.vitaladdeddate || updateddate,
//         })),
//     },
//   };

//   showLoader && showLoader();
//   try {
//     if (inputToEdit.input.vitals && inputToEdit.input.vitals.length > 0) {
//       const result = await EditVitalData(inputToEdit.input);

//       if (result && result.output.message === "Successfully Updated") {
//         showSuccessToast && showSuccessToast("Vitals updated successfully");
//         // fetchpatientdata && fetchpatientdata(patientid, appointmentId);
//         // fetchvitaldata && fetchvitaldata(patientid, appointmentId);
//         // if (fetchVitalsRef && fetchVitalsRef.current) {
//         //   fetchVitalsRef.current(patientid, appointmentId);
//         // }
//       }
//     }
//   } catch (error) {
//     console.error("Error in SubmitEditVitalsForm:", error);
//   }
//   dismissLoader && dismissLoader();
// };

  return (
    <>
      <Box h='calc(100vh - 75px)' overflowY='auto'>
        {appointmentId && (
          <>
        <Box display="flex" justifyContent="center" mx="auto" my='1rem' maxWidth="100%">
          <TabSection
            defaultIndex={0}
            tabs={["Tabular View", "Graphs View"]}
            onClickTab={handleViewTabClick}
            tabBtnStyle={{ minW: { lg: "120px", xl: "140px" } }}
          />
        </Box>
        </>
        )}

      {activeViewTab === "Tabular View" ? (
        // <Box
        //   display="flex"
        //   flexWrap="wrap"
        //   gap="4"
        //   justifyContent="space-between"
        //   mt="2rem"
        //   p='1rem 1.5rem'
        // >
        //   {vitals && vitals.map((vital, index) => {
        //     const statusColor = statusColorMap[vital.status] || "gray.500";
        //     const statusIcon = statusIconMap[vital.status] || "";

        //     return (
        //       <Box
        //         key={index}
        //         border="1px"
        //         borderColor="#E6E7E9"
        //         borderRadius="md"
        //         p={4}
        //         minW="8.75rem"
        //         maxW="48%"
        //         backgroundColor="white"
        //         flex="1 1 48%"
        //         mb={4}
        //       >
        //         <Box display='flex' justifyContent='space-between' alignItems='center'>
        //           <Box display="flex" flexDirection="column">
        //             <Text fontSize="12px" fontWeight="500" color="#6A707D">
        //               {vital.vitalname}
        //             </Text>
        //             <Box display="flex" alignItems="baseline">
        //               <Text
        //                 fontSize={{ base: "18px", md: "22px" }}
        //                 fontWeight="600"
        //               >
        //                 {vital.vitalvalue}
        //               </Text>
        //               <Text
        //                 fontSize={{ base: "12px", md: "15px" }}
        //                 pl="5px"
        //                 fontWeight="400"
        //               >
        //                 {vital.vitalunit}
        //               </Text>
        //             </Box>
        //           </Box>
        //           <Box
        //             as="button"
        //             border="1px solid #E6E7E9"
        //             borderRadius="full"
        //             w="32px"
        //             h="32px"
        //             p="6px"
        //             display="flex"
        //             justifyContent="center"
        //             alignItems="center"
        //             onClick={showGraphs}
        //           >
        //             <Image 
        //               w="100%"
        //               h='16px'
        //               opacity="0.35"
        //               src="/assets/svgs/analytics.svg"
        //             />
        //           </Box>
        //         </Box>

        //         {/* Third line */}
        //         <Box
        //           display="flex"
        //           justifyContent="space-between"
        //           alignItems="center"
        //           mt="0.5rem"
        //         >
        //           <Text fontSize="12px" fontWeight="500" color="#6A707D">
        //             {formatDate(vital.vitaladdeddate)}
        //           </Text>
        //           <Box display="flex" alignItems="center" gap="0.25rem">
        //             {statusIcon && <Image w="12px" h="auto" src={statusIcon} />}
        //             <Text
        //               as="span"
        //               fontSize="12px"
        //               fontWeight="600"
        //               color={statusColor}
        //             >
        //               {vital.vitalstatus}
        //             </Text>
        //           </Box>
        //         </Box>
        //       </Box>
        //     );
        //   })}
        // </Box>

        appointmentId ? (
          // <LabTableView TableData={vitals} />
          <LabTableView 
            TableData={{
              rows: vitalDisplayOrder
                .map(vitalName => {
                   // Special handling for BP
        if (vitalName === "BP") {
          const pairedBP = pairBloodPressures(vitals);
          if (pairedBP.length === 0) return null;
          
          return {
            header: "BP",
            unit: "mmHg",
            values: pairedBP.map(bp => ({
              // onclickfunc: () => editModalfunc(bp.patientvitalid),
              onclickfunc: () => editModalfunc(bp.patientvitalid, true, bp.pairedDate),
              patientvitalid: bp.patientvitalid,
              iscurrent: bp.iscurrent,
              resultvalue: bp.pairedValue,
              documentdate: bp.pairedDate,
              trendcolor: getStatusColor(bp.pairedStatus),
              upper_bound: bp.upper_bound,
              lower_bound: bp.lower_bound
            }))
          };
        }
                  // Find all vitals with this name (not just first one)
                  const matchingVitals = vitals.filter(v => v.vitalname === vitalName);
                  if (matchingVitals.length === 0) return null;

                  // console.log('matchingVitsls: ', matchingVitals)
                  
                  return {
                    header: vitalName,
                    unit: matchingVitals[0].vitalunit, // All same type will have same unit
                    values: matchingVitals.map(vital => ({
                      onclickfunc: () => editModalfunc(vital.patientvitalid),
                      patientvitalid: vital.patientvitalid,
                      iscurrent: vital.iscurrent,
                      resultvalue: vital.vitalvalue,
                      documentdate: vital.vitaladdeddate,
                      trendcolor: getStatusColor(vital.status),
                      upper_bound: null,
                      lower_bound: null
                    }))
                  };
                })
                .filter(Boolean) // Remove any undefined entries
            }}
          />
      //     <LabTableView 
      //   TableData={{
      //     rows: vitalDisplayOrder
      //       .map(vitalName => vitals.find(v => v.vitalname === vitalName))
      //       .filter(Boolean) // Remove any undefined entries
      //       .map(vital => ({
      //         header: vital.vitalname,
      //         unit: vital.vitalunit,
      //         values: [{
      //           resultvalue: vital.vitalvalue,
      //           documentdate: vital.vitaladdeddate,
      //           trendcolor: getStatusColor(vital.status),
      //           upper_bound: null,
      //           lower_bound: null
      //         }]
      //       }))
      //     // rows: vitals.map(vital => ({
      //     //   header: vital.vitalname,
      //     //   unit: vital.vitalunit,
      //     //   values: [{
      //     //     resultvalue: vital.vitalvalue,
      //     //     documentdate: vital.vitaladdeddate,
      //     //     trendcolor: getStatusColor(vital.status),
      //     //     upper_bound: null, // Add if available in your data
      //     //     lower_bound: null  // Add if available in your data
      //     //   }]
      //     // }))
      //   }}
      // />
        ) : (
        <Box
          display="flex"
          flexWrap="wrap"
          gap="4"
          justifyContent="space-between"
          mt="1rem"
          p='1rem 1.5rem'
        >
        <Flex direction="column" gap={4} width="100%">
  {/* Row 1: Body Temperature & Heart Rate */}
  <Flex gap={4} width="100%">
    {vitals
      .filter(vital => ["Heart rate", "Body temperature"].includes(vital.vitalname))
      .sort((a, b) => {
          // Ensure Body temperature comes first
          if (a.vitalname === "Body temperature") return -1;
          if (b.vitalname === "Body temperature") return 1;
          return 0;
        })
      .map((vital, index) => (
        <VitalCard key={index} vital={vital} showGraphs={showGraphs} flex="1" />
      ))
    }
  </Flex>

  {/* Row 2: Respiratory & BP */}
  <Flex gap={4} width="100%">
    {vitals
      .filter(vital => ["Respiratory", "BP"].includes(vital.vitalname))
      .map((vital, index) => (
        <VitalCard key={index} vital={vital} showGraphs={showGraphs} flex="1" />
      ))
    }
  </Flex>

  {/* Row 3: SPO2 only - Make it full width */}
  <Flex width="100%">
    {vitals
      .filter(vital => vital.vitalname === "SPO2")
      .map((vital, index) => (
        <VitalCard key={index} vital={vital} showGraphs={showGraphs} width="50%" />
      ))
    }
  </Flex>

  {/* Row 4: Fasting Blood Glucose & Postprandial Blood Glucose */}
  <Flex gap={4} width="100%">
    {vitals
      .filter(vital => ["Fasting Blood Glucose", "Postprandial Blood Glucose"].includes(vital.vitalname))
      .sort((a, b) => {
          // Ensure Fasting Blood Glucose comes first
          if (a.vitalname === "Fasting Blood Glucose") return -1;
          if (b.vitalname === "Fasting Blood Glucose") return 1;
          return 0;
        })
      .map((vital, index) => (
        <VitalCard key={index} vital={vital} showGraphs={showGraphs} flex="1" />
      ))
    }
  </Flex>
</Flex>
</Box>
        )
      ) : (
        <>
          <Box w='100%' pos='sticky' p='1rem 1.5rem' alignItems='center' top='0' zIndex='999' bg='white' borderBottom='1px solid #E6E7E9' display="flex" justifyContent="space-between" mb="10px">
            {!appointmentId && (
            <Box as='button' w={'100%'} display="flex" alignItems="center" gap="1rem">
              <Image src="/assets/imgs/back-arrow.png"
                onClick={navigateBack}
              />
              <Text fontSize="1.25rem" fontWeight="600">Graphs</Text>
            </Box>
            )}
            {/* <Box display="flex" w={"100%"}> */}
            {!appointmentId && (
            <Box
              display="flex"
              gap="10px"
              zIndex="99"
              alignItems="center"
              px="10px"
              mx="unset"
            // mt="2rem"
            >
              <TabSection
                defaultIndex={3}
                tabs={["Today", "This week", "This month", "This year"]}
                onClickTab={handleTabClick}
                tabBtnStyle={{ minW: 'fit-content', whiteSpace: 'nowrap', fontSize: { base: "0.875rem", md: "1rem" }, lineHeight: 'normal' }}
                tabContainerStyle={{ flexWrap: { base: 'wrap', lg: 'nowrap' }, h: '100%' }}
              />
              <Box
                as="button"
                bg="none"
                p="10px"
                border="1px solid #E6E7E9"
                borderRadius="10px"
                onClick={handleCalendar}
              >
                <Image w="18px" src="/assets/imgs/calendar.png" />
              </Box>
              {isCalendarVisible && (
                <DateRangeIndex
                  ref={openCalendar}
                  onDateChange={(selectedDateValue) =>
                    handlerangedate(selectedDateValue)
                  }
                />
              )}
            </Box>
            )}
            {/* </Box> */}
          </Box>

          {/* <Box display="flex" w={"100%"}>
            <Box
              display="flex"
              gap="10px"
              zIndex="99"
              alignItems="center"
              px="10px"
              mx="unset"
              mt="2rem"
            >
              <TabSection
                defaultIndex={3}
                tabs={["Today", "This week", "This month", "This year"]}
                onClickTab={handleTabClick}
                tabBtnStyle={{ minW: 'fit-content', whiteSpace: 'nowrap', fontSize: { base: "0.875rem", md: "1rem" }, lineHeight: 'normal' }}
                tabContainerStyle={{ flexWrap: { base: 'wrap', lg: 'nowrap' }, h: '100%' }}
              />
              <Box
                as="button"
                bg="none"
                p="10px"
                border="1px solid #E6E7E9"
                borderRadius="10px"
                onClick={handleCalendar}
              >
                <Image w="18px" src="/assets/imgs/calendar.png" />
              </Box>
              {isCalendarVisible && (
                <DateRangeIndex
                  ref={openCalendar}
                  onDateChange={(selectedDateValue) =>
                    handlerangedate(selectedDateValue)
                  }
                />
              )}
            </Box>
          </Box> */}

          {/* <Box
            p={4}
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            gap="20px"
          >
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              gap="20px"
              w="100%"
            >
              {data !== null && data.respiratoryrate.length > 0 ? (
                <GrayCard
                  cardHeader="Respiratory Rate"
                  cardHeaderIcon="/assets/imgs/lungs.png"
                  cardBody={
                    <>
                      <Box w="100%">
                        <Box
                          as="h1"
                          textAlign="left"
                          fontSize="16px"
                          fontWeight="600"
                          pb="10px"
                        >
                          {respiratorylabel} bpm
                        </Box>
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          gap="10px"
                        >
                          <AreaPlotChart
                            originalData={data.respiratoryrate}
                            colors="l(270) 0:#ffffff 0.5:#109E6A 1:#109E6A"
                            lineColor="#109E6A"
                            height="200px"
                            chartName="respChart"
                            dotColor="#109E6A"
                          />
                        </Box>
                      </Box>
                    </>
                  }
                />
              ) : (
                <GrayCard
                  cardHeader="Respiratory Rate"
                  cardHeaderIcon="/assets/imgs/lungs.png"
                  cardBody={
                    <>
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        gap="10px"
                      >
                        <Box
                          as="h1"
                          textAlign="left"
                          fontSize="28px"
                          fontWeight="600"
                        >
                          No data
                        </Box>
                        <Box textAlign="left" fontSize="16px" fontWeight="600">
                          <Image
                            w="100%"
                            opacity="0.5"
                            src="/assets/imgs/res-chart.png"
                          />
                        </Box>
                      </Box>
                    </>
                  }
                />
              )}
            </Box>
            {data !== null && data.bodytemperature.length > 0 ? (
              <GrayCard
                cardHeader="body Temperature"
                cardHeaderIcon="/assets/imgs/thermo.png"
                cardBody={
                  <>
                    <Box w="100%">
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="left"
                        gap="10px"
                      >
                        <Box
                          as="h1"
                          textAlign="left"
                          fontSize="16px"
                          fontWeight="600"
                        >
                          {bodytemplabel} °C
                        </Box>
                        <AreaPlotChart
                          originalData={data.bodytemperature}
                          colors="l(270) 0:#ffffff 0.5:#1C4EC5 1:#1C4EC5"
                          lineColor="#1C4EC5"
                          height="200px"
                          chartName="bodyTempChart"
                          dotColor="#1C4EC5"
                        />
                      </Box>
                    </Box>
                  </>
                }
              />
            ) : (
              <GrayCard
                cardHeader="body Temperature"
                cardHeaderIcon="/assets/imgs/thermo.png"
                cardBody={
                  <>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="left"
                      gap="10px"
                    >
                      <Box
                        as="h1"
                        textAlign="left"
                        fontSize="28px"
                        fontWeight="600"
                      >
                        No data
                      </Box>
                      <Box textAlign="left" fontSize="16px" fontWeight="600">
                        <Image
                          w="100%"
                          opacity="0.5"
                          src="/assets/imgs/temp-chart.png"
                        />
                      </Box>
                    </Box>
                  </>
                }
              />
            )}
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            gap="20px"
            p={4}
          >
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              gap="20px"
              w="100%"
            >
              {data !== null && data.oxygensaturation.length > 0 ? (
                <GrayCard
                  cardHeader="Oxygen Saturation"
                  cardHeaderIcon="/assets/imgs/spo2.png"
                  cardBody={
                    <>
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        gap="10px"
                      >
                        <Box
                          as="h1"
                          textAlign="left"
                          fontSize="16px"
                          fontWeight="600"
                        >
                          {oxygensaturationlabel} %
                        </Box>
                        <AreaPlotChart
                          originalData={data.oxygensaturation}
                          colors="l(270) 0:#ffffff 0.5:#F04438 1:#F04438"
                          lineColor="#F04438"
                          height="290px"
                          chartName="oxySatChart"
                          dotColor="#F04438"
                        />
                      </Box>
                    </>
                  }
                />
              ) : (
                <GrayCard
                  cardHeader="Oxygen Saturation"
                  cardHeaderIcon="/assets/imgs/spo2.png"
                  cardBody={
                    <>
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        gap="10px"
                      >
                        <Box
                          as="h1"
                          textAlign="left"
                          fontSize="28px"
                          fontWeight="600"
                        >
                          No data
                        </Box>
                        <Box textAlign="left" fontSize="16px" fontWeight="600">
                          <Image
                            w="100%"
                            opacity="0.5"
                            src="/assets/imgs/oxygen-chart.png"
                          />
                        </Box>
                      </Box>
                    </>
                  }
                />
              )}
            </Box>
            {data !== null && data.bloodpressure.length > 0 ? (
              <GrayCard
                cardHeader="Blood Pressure"
                cardHeaderIcon="/assets/imgs/blood_pressure.png"
                cardBody={
                  <>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="left"
                      gap="5px"
                    >
                      <GroupedColumnRangePlot
                        data={data.bloodpressure}
                        height={"250px"}
                      />
                    </Box>
                  </>
                }
              />
            ) : (
              <GrayCard
                cardHeader="Blood Pressure"
                cardHeaderIcon="/assets/imgs/blood_pressure.png"
                cardBody={
                  <>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="left"
                      gap="10px"
                    >
                      <Box
                        as="h1"
                        textAlign="left"
                        fontSize="28px"
                        fontWeight="600"
                      >
                        No data
                      </Box>
                      <Box textAlign="left" fontSize="16px" fontWeight="600">
                        <Image
                          w="100%"
                          opacity="0.5"
                          src="/assets/imgs/blood-pressure-charts.png"
                        />
                      </Box>
                    </Box>
                  </>
                }
              />
            )}
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            gap="20px"
            p={4}
          >
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              gap="20px"
              w="100%"
            >
              {data !== null && data.pulse.length > 0 ? (
                <GrayCard
                  cardHeader="heart rate"
                  cardHeaderIcon="/assets/imgs/heart-rate.png"
                  cardBody={
                    <>
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        gap="10px"
                      >
                        <Box
                          as="h1"
                          textAlign="left"
                          fontSize="16px"
                          fontWeight="600"
                        >
                          {pulselabel} bpm
                        </Box>
                        <AreaPlotChart
                          originalData={data.pulse}
                          colors="l(270) 0:#ffffff 0.5:#D80027 1:#D80027"
                          lineColor="#D80027"
                          height="200px"
                          chartName="redChart"
                          dotColor="#D80027"
                        />
                      </Box>
                    </>
                  }
                />
              ) : (
                <GrayCard
                  cardHeader="heart rate"
                  cardHeaderIcon="/assets/imgs/heart-rate.png"
                  cardBody={
                    <>
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        gap="10px"
                      >
                        <Box
                          as="h1"
                          textAlign="left"
                          fontSize="28px"
                          fontWeight="600"
                        >
                          No data
                        </Box>
                        <Box textAlign="left" fontSize="16px" fontWeight="600">
                          <Image
                            w="100%"
                            opacity="0.5"
                            src="/assets/imgs/heart-.png"
                          />
                        </Box>
                      </Box>
                    </>
                  }
                />
              )}
            </Box>
          </Box> */}

          <Box overflowY={"auto"} height={"auto"} mt="2rem" width={"100%"}>
            <Box
              p={4}
              display="flex"
              flexDirection="column" // Changed to column
              justifyContent="space-between"
              gap="20px"
              w="100%"
            >
              {/* Body Temp */}
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                gap="20px"
                w="100%"
              >
                {data !== null && data.bodytemperature.length > 0 ? (
                  <GrayCard
                    cardHeader="Body Temperature"
                    cardHeaderIcon="/assets/imgs/thermo.png"
                    hasFooter={false}
                    cardBody={
                      <>
                        <Box w="100%">
                          <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="left"
                            gap="10px"
                          >
                            <Box
                              as="h1"
                              textAlign="left"
                              fontSize="16px"
                              fontWeight="600"
                            >
                              {bodytemplabel} °F
                            </Box>
                            <AreaPlotChart
                              originalData={data.bodytemperature}
                              colors="l(270) 0:#ffffff 0.5:#1C4EC5 1:#1C4EC5"
                              lineColor="#1C4EC5"
                              height="200px"
                              chartName="bodyTempChart"
                              dotColor="#1C4EC5"
                            />
                          </Box>
                        </Box>
                      </>
                    }
                  />
                ) : (
                  <GrayCard
                    cardHeader="Body Temperature"
                    cardHeaderIcon="/assets/imgs/thermo.png"
                    hasFooter={false}
                    cardBody={
                      <>
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="left"
                          gap="10px"
                        >
                          <Box
                            as="h1"
                            textAlign="left"
                            fontSize="28px"
                            fontWeight="600"
                          >
                            No data
                          </Box>
                          <Box
                            textAlign="left"
                            fontSize="16px"
                            fontWeight="600"
                          >
                            <Image
                              w="100%"
                              opacity="0.5"
                              src="/assets/imgs/temp-chart.png"
                            />
                          </Box>
                        </Box>
                      </>
                    }
                  />
                )}
              </Box>

              {/* Heart Rate */}
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                gap="20px"
                w="100%"
              >
                {data !== null && data.pulse.length > 0 ? (
                  <GrayCard
                    cardHeader="Heart Rate"
                    cardHeaderIcon="/assets/imgs/heart-rate.png"
                    hasFooter={false}
                    cardBody={
                      <>
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          gap="10px"
                        >
                          <Box
                            as="h1"
                            textAlign="left"
                            fontSize="16px"
                            fontWeight="600"
                          >
                            {pulselabel} bpm
                          </Box>
                          <AreaPlotChart
                            originalData={data.pulse}
                            colors="l(270) 0:#ffffff 0.5:#D80027 1:#D80027"
                            lineColor="#D80027"
                            height="200px"
                            chartName="redChart"
                            dotColor="#D80027"
                          />
                        </Box>
                      </>
                    }
                  />
                ) : (
                  <GrayCard
                    cardHeader="Heart Rate"
                    cardHeaderIcon="/assets/imgs/heart-rate.png"
                    hasFooter={false}
                    cardBody={
                      <>
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          gap="10px"
                        >
                          <Box
                            as="h1"
                            textAlign="left"
                            fontSize="28px"
                            fontWeight="600"
                          >
                            No data
                          </Box>
                          <Box
                            textAlign="left"
                            fontSize="16px"
                            fontWeight="600"
                          >
                            <Image
                              w="100%"
                              opacity="0.5"
                              src="/assets/imgs/heart-.png"
                            />
                          </Box>
                        </Box>
                      </>
                    }
                  />
                )}
              </Box>

              {/* Resp Rate */}
              <Box
                display="flex"
                flexDirection="column" // Changed to column for inner boxes too
                justifyContent="space-between"
                gap="20px"
                w="100%"
              >
                {data !== null && data.respiratoryrate.length > 0 ? (
                  <GrayCard
                    cardHeader="Respiratory Rate"
                    cardHeaderIcon="/assets/imgs/lungs.png"
                    hasFooter={false}
                    cardBody={
                      <>
                        <Box w="100%">
                          <Box
                            as="h1"
                            textAlign="left"
                            fontSize="16px"
                            fontWeight="600"
                            pb="10px"
                          >
                            {respiratorylabel} bpm
                          </Box>
                          <Box
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            gap="10px"
                          >
                            <AreaPlotChart
                              originalData={data.respiratoryrate}
                              colors="l(270) 0:#ffffff 0.5:#109E6A 1:#109E6A"
                              lineColor="#109E6A"
                              height="200px"
                              chartName="respChart"
                              dotColor="#109E6A"
                            />
                          </Box>
                        </Box>
                      </>
                    }
                  />
                ) : (
                  <GrayCard
                    cardHeader="Respiratory Rate"
                    cardHeaderIcon="/assets/imgs/lungs.png"
                    hasFooter={false}
                    cardBody={
                      <>
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          gap="10px"
                        >
                          <Box
                            as="h1"
                            textAlign="left"
                            fontSize="28px"
                            fontWeight="600"
                          >
                            No data
                          </Box>
                          <Box
                            textAlign="left"
                            fontSize="16px"
                            fontWeight="600"
                          >
                            <Image
                              w="100%"
                              opacity="0.5"
                              src="/assets/imgs/res-chart.png"
                            />
                          </Box>
                        </Box>
                      </>
                    }
                  />
                )}
              </Box>

              {/* Blood Pressure */}
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                gap="20px"
                w="100%"
              >
                {data !== null && data.bloodpressure.length > 0 ? (
                  <GrayCard
                    cardHeader="Blood Pressure"
                    cardHeaderIcon="/assets/imgs/blood_pressure.png"
                    hasFooter={false}
                    cardBody={
                      <>
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="left"
                          gap="5px"
                        >
                          <GroupedColumnRangePlot
                            data={data.bloodpressure}
                            height={"250px"}
                          />
                        </Box>
                      </>
                    }
                  />
                ) : (
                  <GrayCard
                    cardHeader="Blood Pressure"
                    cardHeaderIcon="/assets/imgs/blood_pressure.png"
                    hasFooter={false}
                    cardBody={
                      <>
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="left"
                          gap="10px"
                        >
                          <Box
                            as="h1"
                            textAlign="left"
                            fontSize="28px"
                            fontWeight="600"
                          >
                            No data
                          </Box>
                          <Box
                            textAlign="left"
                            fontSize="16px"
                            fontWeight="600"
                          >
                            <Image
                              w="100%"
                              opacity="0.5"
                              src="/assets/imgs/blood-pressure-charts.png"
                            />
                          </Box>
                        </Box>
                      </>
                    }
                  />
                )}
              </Box>

              {/* Spo2 */}
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                gap="20px"
                w="100%"
              >
                {data !== null && data.oxygensaturation.length > 0 ? (
                  <GrayCard
                    cardHeader="Oxygen Saturation"
                    cardHeaderIcon="/assets/imgs/spo2.png"
                    hasFooter={false}
                    cardBody={
                      <>
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          gap="10px"
                        >
                          <Box
                            as="h1"
                            textAlign="left"
                            fontSize="16px"
                            fontWeight="600"
                          >
                            {oxygensaturationlabel} %
                          </Box>
                          <AreaPlotChart
                            originalData={data.oxygensaturation}
                            colors="l(270) 0:#ffffff 0.5:#F04438 1:#F04438"
                            lineColor="#F04438"
                            height="290px"
                            chartName="oxySatChart"
                            dotColor="#F04438"
                          />
                        </Box>
                      </>
                    }
                  />
                ) : (
                  <GrayCard
                    cardHeader="Oxygen Saturation"
                    cardHeaderIcon="/assets/imgs/spo2.png"
                    hasFooter={false}
                    cardBody={
                      <>
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          gap="10px"
                        >
                          <Box
                            as="h1"
                            textAlign="left"
                            fontSize="28px"
                            fontWeight="600"
                          >
                            No data
                          </Box>
                          <Box
                            textAlign="left"
                            fontSize="16px"
                            fontWeight="600"
                          >
                            <Image
                              w="100%"
                              opacity="0.5"
                              src="/assets/imgs/oxygen-chart.png"
                            />
                          </Box>
                        </Box>
                      </>
                    }
                  />
                )}
              </Box>

              {/* Fasting Sugar */}
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                gap="20px"
                w="100%"
              >
                {data !== null && data.fastingbloodglucose.length > 0 ? (
                  <GrayCard
                    cardHeader="Fasting Blood Glucose"
                    cardHeaderIcon="/assets/imgs/heart-rate.png"
                    hasFooter={false}
                    cardBody={
                      <>
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          gap="10px"
                        >
                          <Box
                            as="h1"
                            textAlign="left"
                            fontSize="16px"
                            fontWeight="600"
                          >
                            {fastingLable} mg/dL
                          </Box>
                          <AreaPlotChart
                            originalData={data.fastingbloodglucose}
                            colors="l(270) 0:#ffffff 0.5:#D80027 1:#D80027"
                            lineColor="#D80027"
                            height="200px"
                            chartName="redChart"
                            dotColor="#D80027"
                          />
                        </Box>
                      </>
                    }
                  />
                ) : (
                  <GrayCard
                    cardHeader="Fasting Blood Glucose"
                    cardHeaderIcon="/assets/imgs/heart-rate.png"
                    hasFooter={false}
                    cardBody={
                      <>
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          gap="10px"
                        >
                          <Box
                            as="h1"
                            textAlign="left"
                            fontSize="28px"
                            fontWeight="600"
                          >
                            No data
                          </Box>
                          <Box
                            textAlign="left"
                            fontSize="16px"
                            fontWeight="600"
                          >
                            <Image
                              w="100%"
                              opacity="0.5"
                              src="/assets/imgs/heart-.png"
                            />
                          </Box>
                        </Box>
                      </>
                    }
                  />
                )}
              </Box>

              {/* Postprandial Blood Glucose */}
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                gap="20px"
                w="100%"
              >
                {data !== null && data.postprandialbloodglucose.length > 0 ? (
                  <GrayCard
                    cardHeader="Postprandial Blood Glucose"
                    cardHeaderIcon="/assets/imgs/heart-rate.png"
                    hasFooter={false}
                    cardBody={
                      <>
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          gap="10px"
                        >
                          <Box
                            as="h1"
                            textAlign="left"
                            fontSize="16px"
                            fontWeight="600"
                          >
                            {postGlucoseLabel} mg/dL
                          </Box>
                          <AreaPlotChart
                            originalData={data.postprandialbloodglucose}
                            colors="l(270) 0:#ffffff 0.5:#D80027 1:#D80027"
                            lineColor="#D80027"
                            height="200px"
                            chartName="redChart"
                            dotColor="#D80027"
                          />
                        </Box>
                      </>
                    }
                  />
                ) : (
                  <GrayCard
                    cardHeader="Postprandial Blood Glucose"
                    cardHeaderIcon="/assets/imgs/heart-rate.png"
                    hasFooter={false}
                    cardBody={
                      <>
                        <Box
                          display="flex"
                          flexDirection="column"
                          justifyContent="center"
                          gap="10px"
                        >
                          <Box
                            as="h1"
                            textAlign="left"
                            fontSize="28px"
                            fontWeight="600"
                          >
                            No data
                          </Box>
                          <Box
                            textAlign="left"
                            fontSize="16px"
                            fontWeight="600"
                          >
                            <Image
                              w="100%"
                              opacity="0.5"
                              src="/assets/imgs/heart-.png"
                            />
                          </Box>
                        </Box>
                      </>
                    }
                  />
                )}
              </Box>

            </Box>
          </Box>
        </>
      )}
      </Box>

{/* Edit Vitals */}
  {/* <DynamicModal
  ref={editVitals}
  modalHeader={`Edit Vitals`}
  modalWidth='600px'
  modalBody={
    selectedVital ? (
      <Box display="flex" flexDir="column" gap={4}>
        <Text fontWeight="bold">{selectedVital.vitalname} ({selectedVital.vitalunit})</Text>
        <Text fontSize="sm" color="gray.600">Date: {formatDate(selectedVital.vitaladdeddate)}</Text>
        <Box>
          <Text fontSize="sm" mb={2}>Value</Text>
          <input
            type="text"
            value={editValue}
            onChange={e => setEditValue(e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              fontSize: "16px",
              border: "1px solid #E6E7E9",
              borderRadius: "6px"
            }}
          />
        </Box>
      </Box>
    ) : (
      <Box>No vital selected.</Box>
    )
  }
  modalFooterBtn={
    <PrimaryButton
      buttonText="Save"
      btnStyle={{
        w: "100%",
        h: "2.5rem",
      }}
      onClick={() => {
  if (selectedVital) {
    setVitalsState(prev =>
      prev.map(v =>
        v.patientvitalid === selectedVital.patientvitalid
          ? { ...v, vitalvalue: editValue }
          : v
      )
    );
    editVitals.current.closeModal();
  }
}}
      // onClick={() => {
      //   // Save logic here
      //   if (selectedVital) {
      //     // Update the value in the vitals array (or make API call)
      //     // Example: update locally
      //     selectedVital.vitalvalue = editValue;
      //     // Optionally, trigger a re-render or API call
      //     editVitals.current.closeModal();
      //   }
      // }}
    />
  }
/> */}

<DynamicModal
  ref={editVitals}
  modalHeader={`Edit Vitals`}
  modalWidth='600px'
  modalBody={
    selectedBP ? (
      <Box display="flex" flexDir="column" gap={4}>
        <Text fontWeight="bold">Blood Pressure (mmHg)</Text>
        {/* <Text fontSize="sm" color="gray.600">Date: {formatDate(selectedBP.systolic?.vitaladdeddate)}</Text> */}
        <Box>
          {/* <Text fontSize="sm" mb={2}>Date</Text> */}
          {/* <input
            type="date"
            value={editBPDate}
            onChange={e => setEditBPDate(e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              fontSize: "16px",
              border: "1px solid #E6E7E9",
              borderRadius: "6px"
            }}
          /> */}
          <DatePicker
            onDateChange={selectedDateValue => {
              // const formattedDate = moment(selectedDateValue).format("YYYY-MM-DD");
              const formattedDate = moment(selectedDateValue).format("DD-MM-YYYY");
              setEditBPDate(formattedDate);
            }}
            // defaultDate={editBPDate || moment(selectedBP.systolic?.vitaladdeddate).format("DD-MM-YYYY")}
            defaultDate={editBPDate}
            disableFutureDates={true}
            placeholderProp="Date"
            calendarStlye={{ left: "-18px", right: "unset" }}
          />
        </Box>
        <Box>
          {/* <Text fontSize="sm" mb={2}>Systolic</Text> */}
          {/* <input
            type="text"
            value={editSystolic}
            onChange={e => setEditSystolic(e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              fontSize: "16px",
              border: "1px solid #E6E7E9",
              borderRadius: "6px"
            }}
          /> */}
          <PrimaryInput
            variant="bothSide"
            inputPlace="Systolic Value"
            pr="10px"
            inputValue={editSystolic}
            onChange={e => setEditSystolic(e.target.value)}                     
          />
        </Box>
        <Box>
          {/* <Text fontSize="sm" mb={2}>Diastolic</Text>
          <input
            type="text"
            value={editDiastolic}
            onChange={e => setEditDiastolic(e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              fontSize: "16px",
              border: "1px solid #E6E7E9",
              borderRadius: "6px"
            }}
          /> */}
          <PrimaryInput
            variant="bothSide"
            inputPlace="Diastolic Value"
            pr="10px"
            inputValue={editDiastolic}
            onChange={e => setEditDiastolic(e.target.value)}                     
          />
          {/* <DatePicker
            onDateChange={selectedDateValue => {
              const formattedDate = moment(selectedDateValue).format("DD-MM-YYYY");
              setEditBPDate(formattedDate);
            }}
            // defaultDate={editBPDate || moment(selectedBP.systolic?.vitaladdeddate).format("DD-MM-YYYY")}
            defaultDate={editBPDate}
            disableFutureDates={true}
            placeholderProp="Date"
            calendarStlye={{ left: "-18px", right: "unset" }}
          /> */}
        </Box>
      </Box>
    ) : selectedVital ? (
      <Box display="flex" flexDir="column" gap={4}>
        <Text fontWeight="bold">{selectedVital.vitalname} ({selectedVital.vitalunit})</Text>
        {/* <Text fontSize="sm" color="gray.600">Date: {formatDate(selectedVital.vitaladdeddate)}</Text> */}
        <Box>
          {/* <Text fontSize="sm" mb={2}>Date</Text> */}
          <DatePicker
            onDateChange={selectedDateValue => {
              const formattedDate = moment(selectedDateValue).format("DD-MM-YYYY");
              setEditDate(formattedDate);
            }}
            // defaultDate={editDate || moment(selectedVital.vitaladdeddate).format("DD-MM-YYYY")}
            defaultDate={editDate}
            disableFutureDates={true}
            placeholderProp="Date"
            calendarStlye={{ left: "-18px", right: "unset" }}
          />
          {/* <input
            type="date"
            value={editDate}
            onChange={e => setEditDate(e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              fontSize: "16px",
              border: "1px solid #E6E7E9",
              borderRadius: "6px"
            }}
          /> */}
        </Box>
        <Box>
          {/* <Text fontSize="sm" mb={2}>Value</Text>
          <input
            type="text"
            value={editValue}
            onChange={e => setEditValue(e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              fontSize: "16px",
              border: "1px solid #E6E7E9",
              borderRadius: "6px"
            }}
          /> */}
          <PrimaryInput
            variant="bothSide"
            inputPlace="Value"
            pr="10px"
            // value={editValue}
            inputValue={editValue}
            onChange={e => setEditValue(e.target.value)}                     
          />
        </Box>
      </Box>
    ) : (
      <Box>No vital selected.</Box>
    )
  }
  modalFooterBtn={
    <PrimaryButton
      buttonText="Save"
      btnStyle={{
        w: "100%",
        h: "2.5rem",
      }}
      onClick={handleEditVital}
      // onClick={() => {
      //   if (selectedBP) {
      //     // Update both systolic and diastolic locally
      //     setVitalsState(prev =>
      //       prev.map(v =>
      //         v.patientvitalid === selectedBP.systolic.patientvitalid
      //           ? { ...v, vitalvalue: editSystolic }
      //           : v.patientvitalid === selectedBP.diastolic.patientvitalid
      //           ? { ...v, vitalvalue: editDiastolic }
      //           : v
      //       )
      //     );
      //     // Call Edit API for BP
      //     editBPVitals(selectedBP.systolic, selectedBP.diastolic, editSystolic, editDiastolic);
      //     editVitals.current.closeModal();
      //   } else if (selectedVital) {
      //     setVitalsState(prev =>
      //       prev.map(v =>
      //         v.patientvitalid === selectedVital.patientvitalid
      //           ? { ...v, vitalvalue: editValue }
      //           : v
      //       )
      //     );
      //     // Call Edit API for single vital
      //     editSingleVital(selectedVital, editValue);
      //     editVitals.current.closeModal();
      //   }
      // }}
    />
  }
/>

    </>
  );
};

export default ProfileVitalDisplayCard;
